module.exports = __webpack_public_path__ + "img/profile-donor.4df5c23e.jpg";